import React from 'react';

interface Props {
  width?: number;
  height?: number;
}

const Video = ({ width = 48, height = 48 }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1951_113394)">
      <path
        d="M40.5898 0.5H6.74367C5.04433 0.5 3.66675 1.87759 3.66675 3.57692V37.4231C3.66675 39.1224 5.04433 40.5 6.74367 40.5H40.5898C42.2892 40.5 43.6667 39.1224 43.6667 37.4231V3.57692C43.6667 1.87759 42.2892 0.5 40.5898 0.5Z"
        fill="#FCAD0D"
      />
    </g>
    <path
      d="M3.66675 3.57692C3.66675 2.76087 3.99092 1.97825 4.56796 1.40121C5.14499 0.824175 5.92762 0.5 6.74367 0.5L29.2667 0.5L19.6667 40.5H6.74367C5.92762 40.5 5.14499 40.1758 4.56796 39.5988C3.99092 39.0218 3.66675 38.2391 3.66675 37.4231V3.57692Z"
      fill="#FFC857"
    />
    <g filter="url(#filter1_d_1951_113394)">
      <path
        d="M30.1438 19.1251C30.399 19.253 30.6136 19.4494 30.7635 19.6923C30.9135 19.9352 30.9929 20.215 30.9929 20.5005C30.9929 20.7859 30.9135 21.0658 30.7635 21.3087C30.6136 21.5516 30.399 21.748 30.1438 21.8759L19.7376 27.0789C19.5031 27.1961 19.2426 27.2514 18.9807 27.2396C18.7188 27.2278 18.4643 27.1493 18.2413 27.0116C18.0183 26.8738 17.8342 26.6813 17.7065 26.4524C17.5787 26.2235 17.5116 25.9657 17.5115 25.7036V15.2974C17.5116 15.0353 17.5787 14.7775 17.7065 14.5486C17.8342 14.3197 18.0183 14.1272 18.2413 13.9894C18.4643 13.8516 18.7188 13.7731 18.9807 13.7613C19.2426 13.7495 19.5031 13.8048 19.7376 13.922L25.2038 16.6543L30.1438 19.1251Z"
        fill="#F9EEDA"
      />
    </g>
    <path
      d="M8.96446 5.11523H8.28138C7.43171 5.11523 6.74292 5.80403 6.74292 6.6537V7.33677C6.74292 8.18644 7.43171 8.87523 8.28138 8.87523H8.96446C9.81413 8.87523 10.5029 8.18644 10.5029 7.33677V6.6537C10.5029 5.80403 9.81413 5.11523 8.96446 5.11523Z"
      fill="#FAFAFA"
    />
    <path
      d="M24.0072 5.11523H23.3241C22.4744 5.11523 21.7856 5.80403 21.7856 6.6537V7.33677C21.7856 8.18644 22.4744 8.87523 23.3241 8.87523H24.0072C24.8569 8.87523 25.5456 8.18644 25.5456 7.33677V6.6537C25.5456 5.80403 24.8569 5.11523 24.0072 5.11523Z"
      fill="#FAFAFA"
    />
    <path
      d="M39.0519 5.11523H38.3688C37.5191 5.11523 36.8303 5.80403 36.8303 6.6537V7.33677C36.8303 8.18644 37.5191 8.87523 38.3688 8.87523H39.0519C39.9015 8.87523 40.5903 8.18644 40.5903 7.33677V6.6537C40.5903 5.80403 39.9015 5.11523 39.0519 5.11523Z"
      fill="#FAFAFA"
    />
    <path
      d="M16.4867 5.11523H15.8036C14.9539 5.11523 14.2651 5.80403 14.2651 6.6537V7.33677C14.2651 8.18644 14.9539 8.87523 15.8036 8.87523H16.4867C17.3363 8.87523 18.0251 8.18644 18.0251 7.33677V6.6537C18.0251 5.80403 17.3363 5.11523 16.4867 5.11523Z"
      fill="#FAFAFA"
    />
    <path
      d="M31.5279 5.11523H30.8449C29.9952 5.11523 29.3064 5.80403 29.3064 6.6537V7.33677C29.3064 8.18644 29.9952 8.87523 30.8449 8.87523H31.5279C32.3776 8.87523 33.0664 8.18644 33.0664 7.33677V6.6537C33.0664 5.80403 32.3776 5.11523 31.5279 5.11523Z"
      fill="#FAFAFA"
    />
    <path
      d="M8.96446 32.8086H8.28138C7.43171 32.8086 6.74292 33.4974 6.74292 34.3471V35.0301C6.74292 35.8798 7.43171 36.5686 8.28138 36.5686H8.96446C9.81413 36.5686 10.5029 35.8798 10.5029 35.0301V34.3471C10.5029 33.4974 9.81413 32.8086 8.96446 32.8086Z"
      fill="#FAFAFA"
    />
    <path
      d="M24.0072 32.8086H23.3241C22.4744 32.8086 21.7856 33.4974 21.7856 34.3471V35.0301C21.7856 35.8798 22.4744 36.5686 23.3241 36.5686H24.0072C24.8569 36.5686 25.5456 35.8798 25.5456 35.0301V34.3471C25.5456 33.4974 24.8569 32.8086 24.0072 32.8086Z"
      fill="#FAFAFA"
    />
    <path
      d="M39.0519 32.8086H38.3688C37.5191 32.8086 36.8303 33.4974 36.8303 34.3471V35.0301C36.8303 35.8798 37.5191 36.5686 38.3688 36.5686H39.0519C39.9015 36.5686 40.5903 35.8798 40.5903 35.0301V34.3471C40.5903 33.4974 39.9015 32.8086 39.0519 32.8086Z"
      fill="#FAFAFA"
    />
    <path
      d="M16.4867 32.8086H15.8036C14.9539 32.8086 14.2651 33.4974 14.2651 34.3471V35.0301C14.2651 35.8798 14.9539 36.5686 15.8036 36.5686H16.4867C17.3363 36.5686 18.0251 35.8798 18.0251 35.0301V34.3471C18.0251 33.4974 17.3363 32.8086 16.4867 32.8086Z"
      fill="#FAFAFA"
    />
    <path
      d="M31.5279 32.8086H30.8449C29.9952 32.8086 29.3064 33.4974 29.3064 34.3471V35.0301C29.3064 35.8798 29.9952 36.5686 30.8449 36.5686H31.5279C32.3776 36.5686 33.0664 35.8798 33.0664 35.0301V34.3471C33.0664 33.4974 32.3776 32.8086 31.5279 32.8086Z"
      fill="#FAFAFA"
    />
    <defs>
      <filter
        id="filter0_d_1951_113394"
        x="0.179518"
        y="0.5"
        width="46.9745"
        height="46.9745"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.48723" />
        <feGaussianBlur stdDeviation="1.74361" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.2 0 0 0 0 0.215686 0 0 0 0 0.270588 0 0 0 0.08 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1951_113394" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1951_113394"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_1951_113394"
        x="14.0242"
        y="13.7598"
        width="20.4559"
        height="20.4549"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.48723" />
        <feGaussianBlur stdDeviation="1.74361" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.2 0 0 0 0 0.215686 0 0 0 0 0.270588 0 0 0 0.08 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1951_113394" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1951_113394"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default Video;
